import { render, staticRenderFns } from "./editShopMetaTag.vue?vue&type=template&id=0c1aa3cc&scoped=true&"
import script from "./editShopMetaTag.vue?vue&type=script&lang=js&"
export * from "./editShopMetaTag.vue?vue&type=script&lang=js&"
import style0 from "./editShopMetaTag.vue?vue&type=style&index=0&id=0c1aa3cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1aa3cc",
  null
  
)

export default component.exports